module.exports = __webpack_public_path__ + "static/media/ledn.5a1554f6.svg";